import type { ReactNode } from 'react'

import { SquareImageUpload } from '@/components/molecules/square-image-upload.molecule'

interface AgencyLogoUploadProps {
  logoUrl: string | null
  name: string
  onLogoChange: (file: File | null) => void
  onLogoRemove: () => void
  isDisabled?: boolean
  className?: string
}

/**
 * Agency logo upload component. Wrapper around SquareImageUpload with agency-specific defaults.
 */
export const AgencyLogoUpload = ({
  logoUrl,
  name,
  onLogoChange,
  onLogoRemove,
  isDisabled = false,
  className,
}: AgencyLogoUploadProps): ReactNode => {
  return (
    <SquareImageUpload
      imageUrl={logoUrl}
      fallbackText={name}
      onImageChange={onLogoChange}
      onImageRemove={onLogoRemove}
      isDisabled={isDisabled}
      size="lg"
      uploadTooltip="Upload logo"
      changeTooltip="Change logo"
      removeTooltip="Remove logo"
      className={className}
    />
  )
}

AgencyLogoUpload.displayName = 'AgencyLogoUpload'
